import { RequiredMark } from '@/components/ui';

/**
 * 라디오 그룹 한 행(라벨 120px + 라디오 목록). ID49 QuantityDiscountPage 의 RadioRow
 * 패턴을 배송비조건·수기주문 폼에서 공유한다. 고도몰 ID50_2/ID55_1 의 라디오 가이드 UI.
 */
interface RadioRowProps<T extends string> {
  label: string;
  options: ReadonlyArray<T>;
  labels: Record<T, string>;
  value: T;
  onChange: (next: T) => void;
  /** 라디오 input name — 동일 폼 내 그룹 분리. */
  name: string;
  disabled?: boolean;
  /** 행 하단 보더 표기(기본 true). */
  bordered?: boolean;
  /**
   * R4 SSoT — 필수 선택 그룹이면 그룹 라벨(legend) 우측에 RequiredMark 1회 노출.
   * 개별 라디오 옵션엔 붙이지 않는다(그룹 단위 필수 규약).
   */
  required?: boolean;
}

export const RadioRow = <T extends string>({
  label,
  options,
  labels,
  value,
  onChange,
  name,
  disabled = false,
  bordered = true,
  required = false,
}: RadioRowProps<T>) => (
  <div
    className="grid grid-cols-[120px_1fr] items-center gap-4 py-3"
    style={bordered ? { borderBottom: '1px solid var(--divider-soft)' } : undefined}
  >
    <span className="text-[13px] font-medium" style={{ color: 'var(--content-strong)' }}>
      {label}
      {required && <RequiredMark />}
    </span>
    <div role="radiogroup" aria-label={label} className="flex flex-wrap items-center gap-5">
      {options.map((opt) => (
        <label
          key={opt}
          className="inline-flex cursor-pointer items-center gap-2 text-[14px]"
          style={{ color: 'var(--content-default)' }}
        >
          <input
            type="radio"
            name={name}
            checked={value === opt}
            onChange={() => onChange(opt)}
            disabled={disabled}
          />
          {labels[opt]}
        </label>
      ))}
    </div>
  </div>
);
